<template>
  <div class="mx-3">
    <v-row>
      <v-spacer />
      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in employee's name here"
          append-icon="search"
          label="Search Employee Probation"
          hide-no-data
          hide-selected
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :search="search"
      :items="newPositionCompletedProbations"
      :loading="loading"
    >
      <template v-slot:item.start_date="{ item }">
        <span>{{ $moment(item.start_date).format('D MMM YYYY') }}</span>
      </template>

      <template v-slot:item.end_date="{ item }">
        <span>{{ $moment(item.end_date).format('D MMM YYYY') }}</span>
      </template>

      <template v-slot:item.pass_or_fail="{ item }">
        <span
          v-if="item.pass_or_fail"
          class="font-weight-bold green--text"
        > Pass</span>
        <span
          v-else-if="item.pass_or_fail === null"
          class="font-weight-bold warning--text"
        > Pending Action</span>
        <span
          v-else
          class="font-weight-bold error--text"
        >Failed</span>

        <span
          v-if="item.remarks"
          class="pl-1"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-icon
                small
                color="warning"
                v-on="{ ...tooltip }"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <p>{{ item.remarks }}</p>
          </v-tooltip>
        </span>
        <span
          v-else
          class="pl-5"
        />
      </template>

      <template v-slot:item.effective_date="{ item }">
        <span>{{ $moment(item.effective_date).format('D MMM YYYY') }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    data () {
      return {        
        loading: false,
        headers: [
          {
            text: 'Employee',
            align: 'left',
            value: 'employee.person.name',
          },
          {
            text: 'Probation Start Date',
            align: 'center',
            value: 'start_date',
          },
          {
            text: 'Probation End Date',
            align: 'center',
            value: 'end_date',
          },
          {
            text: 'Department',
            align: 'left',
            value: 'department.name',
          },
          {
            text: 'Position',
            align: 'left',
            value: 'position.name',
          },
          {
            text: 'Status',
            align: 'center',
            value: 'pass_or_fail',
          },
          {
            text: 'Effective Date',
            align: 'center',
            value: 'effective_date',
          },
        ],
        search: null,
        newPositionCompletedProbations: [],        
      }
    },  
    created () {
      this.loadCompletedProbations()
    },

    methods: {
      loadCompletedProbations () {
        this.loading = true

        this.$api.employeeProbations().listCompleted()
          .then(res => {
            let newPosition = []
            res.data.map(i => {
              if (i.type === 'new position') {
                newPosition.push(i)
                this.newPositionCompletedProbations = _.orderBy(newPosition, ['effective_date'], ['desc'])
              }            
            })

            this.loading = false          
          })        
      },
    },
  }
</script>
